module.exports = "/assets/data/383d9bd61f175b993f9670e7dc7fe586-M32.data.json";